<div class="header">
    <span> Quotation</span>
    <span class="desc">Create, Review and Send Quote seamlessly.</span>
</div>
<button matTooltip="Download Quote" class="editRequest downloadQuoteBtn" mat-icon-button
    *ngIf="requestService.selectedRequest?.status?.dev_name!='accepted_by_internal_user' && requestService.selectedRequest?.status?.dev_name!='received'"
    (click)="downloadQuote(tradeQuoteTableService.baseQuote)">
    <i class="flaticon-download"></i>
</button>

<ng-container>
    <div class="container">
        <div class="labelSet" fxFlex="30">
            <span class="titleL">Commercials</span>
            <span class="label">Quantity*</span>
            <span class="label">Condition*</span>
            <span class="label">Purchase Locations*</span>
            <span class="label">{{setPriceLabel()}}</span>
            <span class="label">CSC revalidation required? <i matTooltip="Specify whether CSC revalidation is required."
                    matTooltipPosition="right" class="flaticon-message"></i></span>
            <span class="label" *ngIf="showCSCLabel()">CSC Revalidation charge/cont.*</span>
            <span class="label">Storage charge* <i
                    matTooltip="The fee assessed for storing each container in the event that containers are not picked up within the designated timeframe."
                    matTooltipPosition="right" class="flaticon-message"></i></span>
            <span class="label">Free Storage Days* <i
                    matTooltip="Specifies the allocated period during which storage services for the deal are provided at no cost. Please enter the specific number of days designated as 'Free Storage Days' for this particular deal."
                    matTooltipPosition="right" class="flaticon-message"></i></span>
            <span class="label">Purpose of Container</span>
            <span class="label">Manufacturing Year</span>
            <span class="label">Color Preference</span>
            <span class="label">Readiness date for Pick-up*</span>
            <span class="label">Quotation valid till*</span>
            <span class="label">Quote Remarks</span>
            <span class="label addAdHoc" *ngIf="nonConsolidatedQuoteCharges.length != 0"
                (click)="addQuoteItemCharge(tradeQuoteTableService.baseQuote.quote_items)"
                  matTooltip="Add new Additional Charge" matTooltipPosition="right" matTooltipHideDelay="2000"> Additional Charges
                +
                <!-- <button mat-icon-button class=" addBtn " > +
                    </button> -->
            </span>
            <ng-container *ngIf="tradeQuoteTableService?.baseQuote?.quote_items[0].ad_hoc_charges?.length > 0">
                <span *ngIf="nonConsolidatedQuoteCharges.length != 0" style="padding: 5px 0 0 0;">
                    <div class="valueSet">
                        <ng-container *ngFor="let quote of tradeQuoteTableService.baseQuote.quote_items; let i = index">
                            <ng-container *ngIf="i == 0">
                                <div class="gap-2 align-items-center"
                                    *ngFor="let charge of quote.ad_hoc_charges, let i=index">
                                    <app-mat-auto-search [isEditable]="true" [(ngModel)]="charge.quote_charge"
                                        [placeholder]="'Charge Type*'" fxFlex="14em" fxLayout="column" [idField]="null"
                                        [name]="'charge'+i" [options]="nonConsolidatedQuoteCharges" [trim]="true"
                                        [searchable]="true" [labelItemTemplate]="userSelectedItem"
                                        [itemTemplate]="userItem"
                                        class="align-items-center labelInput"></app-mat-auto-search>
                                    <i class="flaticon-delete"
                                        (click)="removeQuoteItemCharge(tradeQuoteTableService.baseQuote.quote_items, i)"
                                        matTooltip="Delete" matTooltipPosition="below" matTooltipHideDelay="2000"></i>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </span>
            </ng-container>
        </div>
        <div fxFlex="67" class="valueSetBox">
            <div class="valueSet" fxFlex="14em"
                *ngFor="let quote of tradeQuoteTableService.baseQuote?.quote_items | orderRequirements: 'container_size_type':'display':'asc'; let i = index">
                <span class="valueSetTitle">{{ quote.container_size_type?.display }}</span>

                <app-number-field [isEditable]="negotiate" [placeholder]="'Quantity'" class="w-100i"
                    [(ngModel)]="quote.quantity" [containerNum]="true" [noDecimal]="true" [maxlength]="4"
                    [(errors)]="tradeQuoteTableService.baseQuote.error.quote_items[i].quantity" [minValue]="1">
                </app-number-field>

                <app-mat-auto-search [isEditable]="negotiate" [displayField]="'value'" [name]="'name'"
                    [(ngModel)]="quote.container_condition" [idField]="null" [listUrl]="containerConditionLists"
                    [setSearchValue]="false" class="w-100i"
                    [(errors)]="tradeQuoteTableService.baseQuote.error.quote_items[i].container_condition">
                </app-mat-auto-search>

                <app-mat-auto-search [(ngModel)]="quote.purchase_locations"
                    [(errors)]="tradeQuoteTableService.baseQuote.error.quote_items[i].purchase_locations"
                    [isEditable]="negotiate" [idField]="null" displayField='name_display' [trim]="true"
                    [multiple]="true" [defaultChip]="false" [clearable]="true" [closeOnSelect]="false"
                    [clearSearchOnAdd]="true" [listUrl]="location_url" name="pods" fxLayout="column"
                    class="w-100i locations">
                </app-mat-auto-search>

                <div class=" valueSetDiv">
                    <logzy-money-field [isEditable]="negotiate" [minValue]="0" [(amount)]="quote.price"
                        [(currencyCode)]="quote.price_currency"
                        [(errors)]="tradeQuoteTableService.baseQuote.error.quote_items[i].price" class="w-100i">
                    </logzy-money-field>

                    <mat-checkbox *ngIf="quote.csc_revalidation_required" color="primary"
                        [ngModel]="quote.csc_validation_included" (ngModelChange)="setRevalidationCharges($event,i)"
                        [disabled]="!negotiate">
                        Inclusive of CSC revalidation charges
                    </mat-checkbox>
                </div>

                <div class="valueSetDiv">
                    <mat-button-toggle-group name="CSC Revalidation" [(ngModel)]="quote.csc_revalidation_required"
                        [disabled]="!negotiate" class="togglebtn1">
                        <mat-button-toggle [value]="true">Yes</mat-button-toggle>
                        <mat-button-toggle [value]="false">No</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>

                <logzy-money-field *ngIf="quote.csc_revalidation_required && !quote.csc_validation_included"
                    [isEditable]="negotiate" [(amount)]="quote.csc_revalidation_charge"
                    [(currencyCode)]="quote.csc_revalidation_charge_currency"
                    [(errors)]="tradeQuoteTableService.baseQuote.error.quote_items[i].csc_revalidation_charge"
                    class="w-100i">
                </logzy-money-field>

                <logzy-money-field [isEditable]="negotiate" [minValue]="0" [(amount)]="quote.storage_charge"
                    [(currencyCode)]="quote.storage_charge_currency"
                    [(errors)]="tradeQuoteTableService.baseQuote.error.quote_items[i].storage_charge" class="w-100i">
                </logzy-money-field>

                <app-number-field [isEditable]="negotiate" [(ngModel)]="quote.free_storage_days" [minValue]="0"
                    [maxlength]="3" [(errors)]="tradeQuoteTableService.baseQuote.error.quote_items[i].free_storage_days"
                    [noDecimal]="true" class="w-100i">
                </app-number-field>

                <div class="valueSetDiv">
                    <mat-button-toggle-group name="Purpose" [(ngModel)]="quote.purpose" [disabled]="!negotiate">
                        <mat-button-toggle value="domestic">Domestic</mat-button-toggle>
                        <mat-button-toggle value="export">Export</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>

                <div class="d-flex gap-4">
                    <app-number-field [isEditable]="negotiate" [(ngModel)]="quote.min_manufacturing_year"
                        style="justify-content: flex-start;" placeholder="Start Year" [minValue]="1980"
                        [maxValue]="currentDate.getFullYear()" [noDecimal]="true" fxFlex="6em"
                        [(errors)]="tradeQuoteTableService.baseQuote.error.quote_items[i].min_manufacturing_year">
                    </app-number-field>
                    <app-number-field [isEditable]="negotiate" [(ngModel)]="quote.max_manufacturing_year"
                        style="justify-content: flex-start;" placeholder="End Year" [minValue]="1980"
                        [maxValue]="currentDate.getFullYear()" [noDecimal]="true" fxFlex="6em"
                        [(errors)]="tradeQuoteTableService.baseQuote.error.quote_items[i].max_manufacturing_year">
                    </app-number-field>
                </div>

                <app-mat-auto-search [(ngModel)]="quote.color_preference" [listUrl]="ralUrl" [idField]="null"
                    [isEditable]="negotiate" [itemTemplate]="ralItemTemplate" [labelItemTemplate]="ralLabelItemTemplate"
                    name="color_preference" fxLayout="column" class="w-100i colorPreference"
                    [(errors)]="tradeQuoteTableService.baseQuote.error.quote_items[i].color_preference">
                </app-mat-auto-search>

                <app-date-field [isEditable]="negotiate" [(ngModel)]="quote.pickup_ready_date" [minDate]="currentDate"
                    [(errors)]="tradeQuoteTableService.baseQuote.error.quote_items[i].pickup_ready_date" class="w-100i"
                    fxLayout="column">
                </app-date-field>

                <app-date-field [isEditable]="negotiate" [(ngModel)]="tradeQuoteTableService.baseQuote.quote_valid_till"
                    [class.hidden]="i!=0" [disabled]="i!=0"
                    [(errors)]="tradeQuoteTableService.baseQuote.error.quote_valid_till" [isEditable]="negotiate"
                    [minDate]="currentDate" class="w-100i" fxLayout="column"></app-date-field>

                <app-text-field [isEditable]="negotiate" [isMultiline]="true" [class.hidden]="i!=0" [disabled]="i!=0"
                    class="w-100i" fxLayout="column" [(ngModel)]="tradeQuoteTableService.baseQuote.remarks"
                    [name]="'remarks'" [(errors)]="tradeQuoteTableService.baseQuote.error.remarks">
                </app-text-field>

                <span style="height: 45px;"> &nbsp; </span>
                <ng-container *ngIf="nonConsolidatedQuoteCharges.length != 0">
                    <div class="vstack " [class.gap-2]="tncExpand">
                        <div class="rGap15 inputs leaseRequest">
                            <ng-container *ngFor="let charge of quote.ad_hoc_charges, let i=index">
                                <logzy-money-field [isEditable]="true" [(amount)]="charge.amount" fxFlex="100"
                                    fxLayout="column" [maxValue]="999999999" [(currencyCode)]="charge.amount_currency"
                                    [(errors)]="charge?.error.amount">
                                </logzy-money-field>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="consolidatedQuoteCharges.length != 0">
    <div class="vstack " [class.gap-2]="tncExpand">
        <div class="HeaderSet">
            <span class="editHead editHeadCursor">
                Request Quote Charges
            </span>
        </div>
        <div class="additionalDetails" style="justify-content: flex-end;" [class.viewExpand]="tncExpand">
            <button mat-raised-button class="clickIt addBtn addReq" [disabled]="!negotiate" (click)="addCharge()"
                    matTooltip="Add new Additional Charge" matTooltipPosition="left" matTooltipHideDelay="2000">+
                Additional Charges
            </button>
            <div fxFlex="100" class="inputs">
                <div fxFlex="100" class="leaseRequest leasebox">
                    <div class="inputs"
                        *ngFor="let charge of tradeQuoteTableService.baseQuote.ad_hoc_charges, let i=index">
                        <div fxFlex="15em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Charge Type*</span>
                            </div>
                            <app-mat-auto-search [isEditable]="true" fxFlex="100" [(ngModel)]="charge.quote_charge"
                                [idField]="null" [name]="'charge'+i" [options]="consolidatedQuoteCharges" [trim]="true"
                                [searchable]="true" [labelItemTemplate]="userSelectedItem" [itemTemplate]="userItem"
                                class="align-items-center"
                                [(errors)]="charge?.error.quote_charge"></app-mat-auto-search>
                        </div>
                        <div fxFlex="15em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Amount*</span>
                            </div>
                            <div fxFlex="100">
                                <logzy-money-field [isEditable]="true" [(amount)]="charge.amount" [maxValue]="999999999"
                                    [(currencyCode)]="charge.amount_currency" [(errors)]="charge?.error.amount">
                                </logzy-money-field>
                            </div>
                        </div>
                        <div class="actionBtn">
                            <i class="flaticon-delete" (click)="removeCharge(i)" matTooltip="Delete"
                                matTooltipPosition="below" matTooltipHideDelay="2000"
                                *ngIf="tradeQuoteTableService.baseQuote.ad_hoc_charges.length > 0"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container>
    <div class="vstack " [class.gap-2]="tncExpand">
        <div class="HeaderSet">
            <span class="editHead editHeadCursor">
                Terms and Conditions
            </span>
        </div>
        <div class="additionalDetails " [class.viewExpand]="tncExpand">
            <app-select-field [isEditable]="!isCustomer && negotiate"
                [hidden]="isCustomer || tradeQuoteTableService.termsConditionList?.length == 1"
                [name]="'termsCondition'" [displayField]="'name'" [(ngModel)]="tradeQuoteTableService.termsAndCondition"
                [options]="tradeQuoteTableService.termsConditionList" fxLayout="column" fxFlex="12em"
                (ngModelChange)="setTermsConditions()"
                [errors]="tradeQuoteTableService.baseQuote.error.terms_and_condition_fk">
            </app-select-field>
            <quill-editor *ngIf="!isCustomer" [styles]="{'min-height': '50px'}"
                [(ngModel)]="tradeQuoteTableService.selectedTermsAndCondition" id="termsAndCondition"
                [modules]="modules" #editor placeholder="Enter Terms and Conditions ....." style="width: inherit;">
            </quill-editor>
            <quill-view *ngIf="isCustomer" [content]="tradeQuoteTableService.selectedTermsAndCondition" format="html"
                theme="snow" style="max-width: 761px;   overflow: auto;"></quill-view>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="requestService.selectedRequest.status.dev_name!='quote_accepted_by_external_user'">
    <div fxFlex="100" class="btnb" fxLayout="row wrap">
        <button *ngIf="isCustomer" class="loadingBtn Save" mat-raised-button
            [disabled]="tradeQuoteTableService.disableSaveButton || !negotiate" (click)="cancelQuoteEditing()">
            <span>Cancel</span>
        </button>
        <button *ngIf="!isCustomer" class="loadingBtn Save" mat-raised-button
            (click)="reviewQuote(tradeQuoteTableService.baseQuote,false)">
            <span>Review Quote</span>
        </button>
        <button class="loadingBtn Save" mat-raised-button
            [disabled]="tradeQuoteTableService.disableSaveButton || !negotiate" (click)="saveQuote()">
            <span *ngIf="!tradeQuoteTableService.disableSaveButton">
                {{isCustomer ? 'Save Negotiation' : 'Save Quotation'}}
            </span>
            <div *ngIf="tradeQuoteTableService.disableSaveButton" class="p03">
                <i class="flaticon-loading spin"></i>
                <span>Saving...</span>
            </div>
        </button>
    </div>
</ng-container>
<ng-container *ngIf="requestService.selectedRequest.status.dev_name=='quote_accepted_by_external_user'">
    <div fxFlex="100" class="btnb" fxLayout="row wrap">
        <button *ngIf="!isCustomer" class="loadingBtn Save" mat-raised-button
            (click)="reviewQuote(tradeQuoteTableService.baseQuote, true)">
            <span>Create Booking</span>
        </button>
    </div>
</ng-container>
<ng-container>
    <div class="vstack " [class.gap-2]="uploadDocExpand">
        <div class="HeaderSet">
            <span class="editHead editHeadCursor" (click)="uploadDocExpand = !uploadDocExpand">
                Comments/Attachments
                <i class="flaticon-down-chevron" [ngClass]="uploadDocExpand? 'more':'' "></i>
            </span>
        </div>
        <div class="additionalDetails" [class.viewExpand]="uploadDocExpand">
            <mat-tab-group animationDuration="1500ms">
                <mat-tab label="Comments">
                    <div class="additionalDetails" [class.viewExpand]="remarkExpand">
                        <logzy-quote-remarks fxLayout="row wrap">
                        </logzy-quote-remarks>
                    </div>
                </mat-tab>
                <mat-tab label="Attachments">
                    <logzy-request-documents fxFlex="100"></logzy-request-documents>
                    <!-- <div class="mnrList">
                        <app-mat-auto-search [isEditable]="true" [label]="'Document Type*'"
                            [class.marginb-4]="!showUpload" [(ngModel)]="selectedDocument" [displayField]="'name'"
                            [name]="'name'" [defaultChip]="false" [idField]="null" [options]="documentTypeList"
                            [setSearchValue]="false" fxFlex="17em" fxLayout="column" [clearable]="true"
                            (change)="showDocumentUpload($event)">
                        </app-mat-auto-search>
                        <div class="choose" fxFlex="100" fxLayout="column" *ngIf="showUpload">
                            <app-file-field [isEditable]="true" [fileDropArea]="true" [showUploadedList]="true"
                                [(ngModel)]="tradeQuoteTableService.baseQuote.uploaded_documents"
                                [documentTypeDevName]="selectedDocumentType" [name]="'uploaded_documents'"
                                fxLayout="row" class="fileDrop dmgDrop">
                            </app-file-field>
                        </div>
                    </div> -->
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</ng-container>

<ng-template #ralItemTemplate let-item>
    <div class="ral-container">
        <div class="color-box" [style.background-color]="item?.HEX"></div>
        <div class="color">
            <span class="ral-code">{{item?.RAL ?? '-'}}</span>
            <span class="color-name">{{item?.name ?? '-'}}</span>
        </div>
    </div>
</ng-template>

<ng-template #ralLabelItemTemplate let-item>
    <div class="ral-container">
        <div class="color-box" [style.background-color]="item?.HEX"></div>
        <div class="color">
            <!-- <span class="ral-code">{{item?.RAL ?? '-'}}</span> -->
            <span class="color-name">{{item?.name ?? '-'}} </span>
        </div>
    </div>
    <!-- {{item?.name ?? '-'}} -->
</ng-template>

<ng-template #userItem let-item let-index>
    <div fxFlex=" 100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{item?.charge?.print_name}}
        </span>
        <span class="email">
            {{item?.charge?.charge_code}}
        </span>
    </div>
</ng-template>

<ng-template #userSelectedItem let-item>
    {{item?.charge?.print_name}}
</ng-template>
